<template>
    <a
        class="u-text-underlined"
        @click="onClickDo"
        >{{ value }}</a
    >
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'OrderLinkDetailsCellRenderer',
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    computed: {
        value() {
            return this.params.value;
        },
    },
    methods: {
        ...mapActions({
            setOrderDetailSectionConfig: 'orders/detailSection/setConfigDataBeforeShow',
        }),
        async onClickDo(e) {
            e.preventDefault();
            const { value } = this;
            await this.setOrderDetailSectionConfig({
                filter: {
                    orderId: value,
                },
            });
            this.$router.push({ name: `orderDetailsModal`, params: { orderId: value } });
        },
    },
};
</script>
